import script from "./NewsItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsItem.vue?vue&type=script&setup=true&lang=js"

import "./NewsItem.vue?vue&type=style&index=0&id=e16cada0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e16cada0"]])

export default __exports__